// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__jdQsM","spinnerWrapper":"Spinner_spinnerWrapper__vkFR1","spinnerIcon":"Spinner_spinnerIcon__VIwvT","spin":"Spinner_spin__DdZBA"};